import { updateNotification } from 'lib/api/notification';
import { changeProp } from 'modules/notificationSlice';
import { useMutation, useQueryClient } from 'react-query';
import { useDispatch } from 'react-redux';

const useNotificationTableItem = () => {
  const queryClient = useQueryClient();
  const dispatch = useDispatch();

  const { mutate } = useMutation(updateNotification, {
    onError: error => {
      if (error?.response.status === 500) {
        dispatch(changeProp({ key: 'error', value: true }));
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries('notificationList');
    },
  });

  const onUpdate = id => {
    mutate({ id });
  };

  return { onUpdate };
};

export default useNotificationTableItem;
